import { AppSettings } from "../Constants/AppSettings"
import { controllers } from "../Controllers/Controllers"
import { baseResponse } from "../DataTypes/baseResponse"

const noInternetConnectionError:baseResponse = {
    data: [],
    status: false,
    statusCode: 0,
    statusMessage: 'The same internet connection error'
}

export const duringParsingError:baseResponse = {
    data: [],
    status: false,
    statusCode: 1,
    statusMessage: 'Error during parsing json response'
}

export const fetchData = async (
    url = '',
    type = 'POST',
    body = {},
    contentType = "application/json"
) => {
    try{
        var bodySend:{body: any, headers?:any} = {body: null}
        bodySend.headers = {
            'Content-Type': contentType,
        }
        if(type !== "GET" && contentType === "application/json"){
            // @ts-ignore
            bodySend.body = JSON.stringify(body)
        } else if(contentType === "multipart/form-data"){
            bodySend.body = body
            bodySend.headers = {}
        }
        const response = await fetch(
            `${AppSettings.endpoint}/${url}`,
            {
                method: type,
                ...bodySend
            }
        )
        if (response.ok) {
            try{
                const json = await response.text();
                // console.warn("JSON2",json)
                return JSON.parse(json);
            } catch(e){
                return duringParsingError
            }
        } else {
            console.log('!OK')
            return response
        }
    } catch(e){
        console.log('error', e)
        return noInternetConnectionError
        // throw e
    }
}

